import { Controller } from "stimulus";
import _ from 'lodash';
import RequestQueue from '../classes/RequestQueue';

export default class extends Controller {
  static targets = ['input', 'inputMessage', 'resultContainer']
  static classes = ['message', 'input']
  static values = { additionalData: Object }

  handleAddButton() {
    this.addToWatchList(this.inputTarget.dataset.result, this.inputTarget.dataset.displayResult);
  }

  handleInput() {
    this.resetMessage();
  }

  showMessage(message) {
    this.inputTarget.classList.add(this.inputClass);
    this.inputMessageTarget.classList.add(this.messageClass);
    this.inputMessageTarget.innerHTML = message;
  }

  resetMessage() {
    this.inputTarget.classList.remove(this.inputClass);
    this.inputMessageTarget.classList.remove(this.messageClass);
    this.inputMessageTarget.innerHTML = null;
  }

  async addToWatchList(securityId, symbol) {
    this.__resetInputField();
    if (_.isEmpty(securityId)) {
      this.showMessage('Please enter a security symbol');
      return;
    }
    let data = this.additionalDataValue;
    const res = await RequestQueue.addToQueue({
      method: 'put',
      url: `/api/dividend/watch_list/${securityId}/`,
      data
    });
    if (res instanceof Error) {
      this.showMessage(res.response.data.error_message);
    } else {
      let securityId = res.data.security_id;
      this.__emitWatchlistUpdateEvent('add', securityId, symbol);
    }
  }

  __resetInputField = () => {
    this.inputTarget.dataset.result = '';
    this.inputTarget.dataset.displayResult = '';
    this.inputTarget.value = '';
  }

  __emitWatchlistUpdateEvent(action, securityId, symbol) {
    const msg = action == 'remove' ? `Removed ${symbol} from your watchlist` : `Added ${symbol} to your watchlist`;
    EventManager.emit('flash-message', {
      status: 'SUCCESS',
      title: msg
    })

    EventManager.emit('watchlist-updated', {
      securityId: securityId,
      action: action
    })
  }
}
